<template>
  <div class="videowrapper">
    <div v-if="hasText" class="media-video-text-block h-100 w-100">
      <div class="w-100 h-100 div_general">
        <b-row class="w-100 h-100 d-flex position-relative offre_special_container">
          <b-col cols="8" class="h-25 mt-2">
            <div v-if="content.petiteNote" class="boite_petite_note">
              <span class="petite_note graphik_bold" v-html="content.petiteNote"> </span>
            </div>
          </b-col>
          <b-col
            class="d-flex flex-column align-items-center align-items-md-start py-1 py-md-0 justify-content-center position-static col-12 col-md-4 barreDessousMobile mobile_text_center"
            :style="styleObject"
          >
            <div>
              <div
                v-if="content.surTitre"
                class="offre_surtitre graphik_bold"
                v-html="content.surTitre"
              ></div>
              <h3 class="titre graphik_bold" v-html="content.titre"></h3>
            </div>
            <div class="sousTitre" v-html="content.sousTitre"></div>
            <b-link
              v-if="content.lien"
              :id="content['@id']"
              v-bind="jel_getLienBinding(content.lien)"
              :ga-img-name="imageName"
              class="stretched-link offre-speciale"
              :data-tag="`${jel_getNomRouteCourante()} - ${content.titre.replace(
                /&nbsp;/g,
                ' '
              )} - ${content.sousTitre} - ${content.dataTag}`"
            >
              <button
                class="videobtn btn graphik_bold"
                :style="[
                  { 'border-color': content.borderColorBtn },
                  { 'background-color': content.colorBtn },
                ]"
              >
                {{ content.texteBouton }}
              </button>
            </b-link>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="yt-ambiance-video" :style="{ 'background-image': 'url(' + content.bgImage + ')' }">
      <div class="player-container">
        <div class="content-inner youtube-container embed-responsive embed-responsive-16by9">
          <iframe
            class="iframe_video"
            :width="largeur"
            height="380"
            :data-src="lien"
            type="text/html"
            frameborder="0"
            allowfullscreen
            title="iFrame MediaVideo"
          >
          </iframe>

          <!-- Message & "I accept" button -->

          <div class="video-consent-overlay">
            <div class="scrollable-section">
              <div class="logo">
                <svg-icon icon-name="youtube"></svg-icon>
              </div>
              <div class="video-consent-overlay-text">
                <p>
                  {{ $t('youtubeVideoConsent.texte') }}
                </p>
              </div>
            </div>
            <button class="video-consent-overlay-accept-button">
              {{ $t('youtubeVideoConsent.texteBoutonAccept') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleYoutubeConsent } from '@/helpers/ConsentHelpers';

export default {
  name: 'MediaVideo',
  props: { content: { type: Object, required: true } },
  data() {
    const { largeur } = this.content;
    const { hauteur } = this.content;
    const { videoLien } = this.content;
    const autoplay = this.content.autoplay ? 1 : 0;

    return {
      player: null,
      total_video_time: 0,
      autoplay,
      largeur,
      hauteur,
      videoLien,
      origin: window.location.origin,
      lien: `https://www.youtube.com/embed/${videoLien}?playlist=${videoLien}&amp;autoplay=${autoplay}&amp;controls=0&amp;loop=1&amp;modestbranding=1&amp;mute=1&amp;showinfo=0&amp;rel=0&amp;wmode=opaque&amp;enablejsapi=1&amp;origin=${origin}&amp;widgetid=2`,
    };
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    styleObject() {
      let textColor = 'black';
      let textMobColor = 'black';
      let backgroundColor = 'transparent';
      let backgroundMobColor = '#efefef';

      if (this.$mq == 'sm' && this.content.secBgThemeColor) {
        return {
          'background-color': this.content.secBgThemeColor,
          color: textColor,
        };
      }

      if (this.content.couleurTitre) {
        textColor = this.content.couleurTitre;
      }
      if (this.content.mobCouleurTitre) {
        textMobColor = this.content.mobCouleurTitre;
      }
      if (this.content.couleurFondTitre) {
        backgroundColor = this.content.couleurFondTitre;
      }
      if (this.content.mobCouleurFondTitre) {
        backgroundMobColor = this.content.mobCouleurFondTitre;
      }

      if (this.$mq == 'sm') {
        return {
          'background-color': backgroundMobColor,
          color: textMobColor,
        };
      }

      return {
        'background-color': backgroundColor,
        color: textColor,
      };
    },
    imageName() {
      // TODO: M5
      // if (
      //   jel_getFichierSrc(this.content.imageFond) &&
      //   jel_getFichierSrc(this.content.imageFond).length > 0
      // ) {
      //   return jel_getFichierSrc(this.content.imageFond).substring(
      //     parseInt(jel_getFichierSrc(this.content.imageFond).lastIndexOf('/') + 1),
      //     jel_getFichierSrc(this.content.imageFond).lastIndexOf('.')
      //   );
      // }
      return '';
    },
    hasText() {
      return (
        (this.content.petiteNote ||
          this.content.surTitre ||
          this.content.titre ||
          this.content.sousTitre ||
          this.content.lien) ??
        false
      );
    },
  },
  mounted() {
    handleYoutubeConsent();
  },
};
</script>

<style lang="scss" scoped>
.videowrapper {
  height: 380px;
  @include media-breakpoint-down(sm) {
    height: 300px;
  }
}

.yt-ambiance-video {
  max-height: 380px;

  background-position: left center;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-color: transparent;
  background-size: cover;
  background-repeat: no-repeat;

  @include media-breakpoint-down(md) {
    background-position-y: -75px;
    padding-top: 0;
  }
}

.iframe_video {
  position: relative;
  top: -17vw;
  left: 0;
  width: 100vw;
  height: calc(100vw / 1.77);
  min-height: 380px;
}

.media-video-text-block {
  position: absolute;
  z-index: 1;
}

.row {
  background-position: center;
  background-repeat: no-repeat;
  margin: 0px !important;
}

.row.bgcover {
  background-size: cover;
}

.container-fluid {
  padding: 0;
}

.div_general {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.main-bingo {
  .boite_petite_note {
    background-color: rgba(0, 0, 0, 0.65);
    width: fit-content;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3%;
    padding: 1.5% 3%;
    color: white;
    @include ms-respond(font-size, 0);
  }

  .titre {
    @include ms-respond(font-size, 4);
    margin: 0;
    line-height: 1;

    @include media-breakpoint-down(sm) {
      font-size: 18px;
      padding-top: 0.75rem;
    }
  }

  .btn {
    margin-bottom: 12%;
    text-transform: uppercase;
    color: black;

    @include ms-respond(font-size, -1);
    border-radius: 4rem;

    @include media-breakpoint-down(sm) {
      padding: 1rem 2.5rem;
      border-radius: 20px;
    }
  }

  .offre_surtitre {
    @include ms-respond(font-size, 0);
    text-align: left;
  }

  .sousTitre {
    @include ms-respond(font-size, 0);
    margin: 0;
    margin-top: 2%;

    @include media-breakpoint-down(sm) {
      font-size: 12px;
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;
    }
  }

  @include media-breakpoint-up(md) {
    .yt-ambiance-video {
      background-image: none !important;
    }
  }

  @include media-breakpoint-down(sm) {
    .offre_surtitre {
      font-size: 12px;
    }

    .barreDessousMobile {
      height: 50%;
      background-color: #efefef; //couleur background par defaut
    }

    .offre_special_container {
      align-content: space-between;
      align-items: center;
    }

    .mobile_text_center {
      text-align: center;
    }
  }
}
</style>
